module.exports = __webpack_public_path__ + "static/media/joe-full.d90d9896.png";